import React from "react";

export default function Loader(props) {
    const CNLoader = ["loader"];
    const CNLoaderContent = ["loader-content"];
    props.show && CNLoader.push("show");
    props.show && CNLoaderContent.push("show");

    return (
        <>
            <div className={CNLoader.join(" ")}></div>
            <div className={CNLoaderContent.join(" ")}>
                <img src="/img/logotype-black.svg" alt="PGBLDR.com" />
            </div>
        </>
    );
}
